export function Footer() {
  return (
    <footer className="app-footer">
      <p>Built with React + TypeScript</p>
    </footer>
  )
}

export default Footer
